'use client';

import { FC } from 'react';

export interface LandingCustomerStoriesProps {
  title: string;
  subtitle: string;
  description: string;
  cta?: {
    href: string;
    title: string;
  };

  gridItems: {
    image: React.ReactNode;
    title: string;
    description: string;
    href: string;
  }[];
}

const LandingCustomerStories: FC<LandingCustomerStoriesProps> = ({
  title,
  gridItems = [],
}) => {

  return (
    <>
      <section className="flex pt-[80px] px-[24px] overflow-scroll md:overflow-auto">
        <div className="w-full text-center">
          <h2 className="text-display3 text-blue-900 font-500">{title}</h2>
        </div>
      </section>
      <section className="flex pt-0 px-[24px] overflow-scroll md:overflow-auto">
        <div className="w-full mx-auto max-w-grid flex md:grid grid-cols-[repeat(4,minmax(150px,1fr))] md:grid-cols-4 gap-x-2 items-center">
          {gridItems.map((item, index) => (
            <div key={`grid-items-${index}`} className="flex flex-wrap flex-col w-full min-h-[348px] min-w-[256px] md:min-w-full items-start justify-between bg-violet-100 rounded-[12px] px-[32px] pt-[24px] pb-[48px] mt-[48px]">
              <div className="flex w-full justify-center">
                {item.image}
              </div>
              <div className="flex flex-wrap w-full justify-center">
                <div className="flex w-full text-display1 font-500 text-blue-900 justify-center">
                  {item.title}
                </div>
                <div className="flex w-full text-p2 text-blue-900 justify-center">
                  {item.description}
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>
    </>
  );
};

export default LandingCustomerStories;
